import * as React from 'react'
import { FC } from 'react'

import Box from '@mui/material/Box'

interface Props {
  children: React.ReactNode
}

export const EntityCardBody: FC<Props> = (props) => {
  const { children } = props

  return (
    <Box px={2} py={1}>
      {children}
    </Box>
  )
}

EntityCardBody.displayName = 'EntityCardBody'
